// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jTLj","col":"styles_col__1jp2D"};